var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53349 14.6402L9.78256 20.9391C10.0819 21.2983 10.6667 21.0866 10.6667 20.619V17.6786C10.6667 17.5405 10.7786 17.4286 10.9167 17.4286H17.0833C17.2214 17.4286 17.3333 17.5405 17.3333 17.6786V20.619C17.3333 21.0866 17.9181 21.2983 18.2174 20.9391L23.4665 14.6402C23.7756 14.2693 23.7756 13.7307 23.4665 13.3598L18.2174 7.06093C17.9181 6.70168 17.3333 6.91338 17.3333 7.38103V10.3214C17.3333 10.4595 17.2214 10.5714 17.0833 10.5714H10.9167C10.7786 10.5714 10.6667 10.4595 10.6667 10.3214V7.38102C10.6667 6.91338 10.0819 6.70168 9.78256 7.06093L4.53349 13.3598C4.22445 13.7307 4.22445 14.2693 4.53349 14.6402Z",
    stroke: "#050022",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0e85007a44d33d31d6adb70a0c5b8b7f.svg";
export { ForwardRef as ReactComponent };